import { render, staticRenderFns } from "./InstructorsTableAvailableCell.vue?vue&type=template&id=4b4eabfa&"
import script from "./InstructorsTableAvailableCell.vue?vue&type=script&lang=ts&"
export * from "./InstructorsTableAvailableCell.vue?vue&type=script&lang=ts&"
import style0 from "./InstructorsTableAvailableCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
